import { render, staticRenderFns } from "./OperationManagement.vue?vue&type=template&id=585cff67&scoped=true&"
import script from "./OperationManagement.vue?vue&type=script&lang=js&"
export * from "./OperationManagement.vue?vue&type=script&lang=js&"
import style0 from "./OperationManagement.vue?vue&type=style&index=0&id=585cff67&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585cff67",
  null
  
)

export default component.exports